import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

import "../styles/Offer.scss";

import PageviewIcon from "@material-ui/icons/Pageview";
import DataUsageIcon from "@material-ui/icons/DataUsage";
import PeopleIcon from "@material-ui/icons/People";
import TvIcon from "@material-ui/icons/Tv";

gsap.registerPlugin(ScrollTrigger);

function Offer() {
  const divRef = useRef(null);
  useEffect(() => {
    const div = divRef.current.children;
    gsap.fromTo(
      div,
      { x: "-=300", autoAlpha: 0 },
      {
        duration: 0.5,
        x: "+=300",
        stagger: 0.2,
        autoAlpha: 1,
        ease: "none",
        scrollTrigger: {
          id: "offer",
          trigger: div,
          start: "top center",
        },
      }
    );
  }, []);
  return (
    <div className="offerContainer" id="offer" ref={divRef}>
      <div className="offerHead">
        <h2>We Provide</h2>
        <p>the best service for our clients to boost their brand with us</p>
      </div>
      <div className="windows">
        <div className="window">
          <div className="head">
            <PageviewIcon className="icon" style={{ fill: "green" }} />
            <h4>Search Engine Optimization</h4>
          </div>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras
            facilisis eu eros eu malesuada. Integer ac mattis purus.
          </p>
        </div>
        <div className="window">
          <div className="head">
            <DataUsageIcon
              className="icon"
              style={{ fill: "rgb(170, 0, 0)" }}
            />
            <h4>Data Analyst & Speed Optimization</h4>
          </div>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras
            facilisis eu eros eu malesuada. Integer ac mattis purus.
          </p>
        </div>
        <div className="window">
          <div className="head">
            <PeopleIcon className="icon" style={{ fill: "rgb(230, 195, 0)" }} />
            <h4>Social Media Advertising</h4>
          </div>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras
            facilisis eu eros eu malesuada. Integer ac mattis purus.
          </p>
        </div>
        <div className="window">
          <div className="head">
            <TvIcon className="icon" style={{ fill: "rgb(3, 0, 190)" }} />
            <h4>Media Promotion</h4>
          </div>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras
            facilisis eu eros eu malesuada. Integer ac mattis purus.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Offer;
